<template>
  <div class="boardFooterWrapper">
    <div class="boardFooterDiv">
      <div class="boardFooterInfoDiv" v-bind:style="'flex: 0.4;'">
        <span>상호: 굿윌헌팅 주식회사</span>
        <br>
        <span>대표자명: 박성용</span>
      </div>
      <div class="boardFooterInfoDiv" v-bind:style="'flex: 0.6;'">
        <span>주소: 인천광역시 부평구 부평대로 293, 910호 (청천동, 부평테크시티)</span>
        <br>
        <span>사업자등록번호: 146-86-00182</span>
        <br>
        <span>유선전화번호: 02-2039-0623</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.boardFooterWrapper{
  height: 82px;
  background-color: #F8F8F8;
}

.boardFooterDiv {
  display : -webkit-flex;
  display : flex;
  margin-left: 32px;
  margin-top: 16px;
}

.boardFooterInfoDiv{
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/board/elements/boardFooterLeftSide.vue